import employerPaymentsForm from "form/modal/employerPayments";
import { FORM_EDIT_EMPLOYER_PAYMENTS } from "../constants";

export const EmployerPaymentsForm = employerPaymentsForm.createInPageContainer(FORM_EDIT_EMPLOYER_PAYMENTS);
